/**
 * The enum containing all the services that exist within the app - a kind of service-encyclopedia.
 *
 * Used by DI
 * Each new service has to be added here and all globally available contexts should be here as well.
 */
enum DIServices {
    AppContext
    // SettingsService,

}

export default DIServices;